
import axios from 'axios'

export default async() => {
    const response = await axios.get(`/country`)
    return response.data
}